import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConfigurationService } from 'src/services/configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationGuard implements CanActivate {

  constructor(
    private router: Router,
    private configurationService: ConfigurationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    try {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.configurationService.configuration()) {
          await this.configurationService.fetch();
        }
      }
      return true;
    } catch (error) {
      return this.router.createUrlTree(['/login']);
    }
  }
}